<template>
  <page-layout
    :breadcrumbs="breadcrumbs"
    :title="title"
  >
    <o-main-progress v-if="!loadedAll"/>
    <Kyc v-if="loadedAll"
      :id="id"
      @error="error"
      @terminado="terminadoPaso"
      @cambiado="cambiadoAlert = $event"
      :simplificada="false"
    />
  </page-layout>
</template>

<script>
import Kyc from '@/components/reservas/kyc/Kyc'
import modulos from '@/mixins/modulos'
import alertBeforeExit from '@/mixins/alertBeforeExit'
import { mapGetters, mapActions } from 'vuex'

export default {
  mixins: [modulos, alertBeforeExit],
  props: {
    id: {
      required: true
    }
  },
  data () {
    return {
      loadedAll: false,
      pasoActual: 'kyc'
    }
  },
  components: {
    Kyc
  },
  async created () {
    try {
      await this.loadReserva(this.id)
      await Promise.all([
        this.loadMaestros(),
        this.loadTiposDocumentos(),
        this.loadAllCompradores(this.id)
      ])
      this.comprobarPasoReserva(this.pasoActual, this.reserva)
    } catch (error) {
      this.$router.push({name: 'reservas.list'})
      if (!error.code || error.code !== 1) {
        this.addAlert({texto: error.message, color: 'error'})
      }
    }
  },
  computed: {
    ...mapGetters({
      reserva: 'reservas/_id/getActual',
      modulos: 'modulosOrdenes/modulos/getAll'
    })
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      loadReserva: 'reservas/_id/load',
      loadMaestros: 'maestros/load',
      loadAllCompradores: 'compradores/loadAll',
      loadTiposDocumentos: 'maestros/loadTiposDocumentos'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/reservas/_id/kyc.vue